import React from 'react';
import { useDispatch } from 'react-redux';
import PopOverContainer from '../../components/deprecated/PopOverContainer';
import UpgradeButton from '../../organization/UpgradeButton';
import { openPricingModal } from '../../utils/url/pricingPath';
import styles from './InsightsRestriction.module.scss';

interface InsightsRestrictionProps {
  olderThan?: number;
  onUpgradeClick?: () => void;
}

const InsightsRestriction = ({
  olderThan,
  onUpgradeClick,
}: InsightsRestrictionProps) => {
  const dispatch = useDispatch();

  const upgradeClick = () => {
    onUpgradeClick?.();
    openPricingModal(dispatch, 'usageAnalytics');
  };

  return (
    <PopOverContainer width="auto" noPadding>
      <div className={styles.container}>
        <div className={styles.note}>
          {olderThan
            ? `Upgrade to view data older than ${olderThan} days.`
            : 'Upgrade to view older analytics data.'}
        </div>
        <UpgradeButton onClick={() => upgradeClick()} size="small">
          View upgrade options
        </UpgradeButton>
      </div>
    </PopOverContainer>
  );
};

export default InsightsRestriction;
